import {
  FilterMode,
  SignedEditionSadaicWorkflowStateCreateMutationVariables,
  SignedEditionSadaicWorkflowState_OrderBy,
  SignedEditionSadaicWorkflowState,
  SortOrder,
  SignedEditionSadaicWorkflowState_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const signedEditionSadaicWorkflowStateService = {
  createOne: buildCreateOne(
    (
        signedEditionSadaicWorkflowStateCreateVariables: SignedEditionSadaicWorkflowStateCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.signedEditionSadaicWorkflowStateCreate(
          signedEditionSadaicWorkflowStateCreateVariables
        );
        return result.signedEditionSadaicWorkflowStateCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.signedEditionSadaicWorkflowStateOne({ id });
    return result.signedEditionSadaicWorkflowStateOne as SignedEditionSadaicWorkflowState;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: SignedEditionSadaicWorkflowState_OrderBy[] | null = null,
    filter: SignedEditionSadaicWorkflowState_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: SignedEditionSadaicWorkflowState_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.signedEditionSadaicWorkflowStateListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.signedEditionSadaicWorkflowStateListWithOffset
    ) as SignedEditionSadaicWorkflowState[];
    return { list, orderBy };
  },
};
